/* eslint-disable  */

export default {
    "About us": "Giới thiệu",
    "Account": "Tài khoản",
    "Add new address": "Thêm địa chỉ mới",
    "Add to compare": "Thêm để so sánh",
    "Add to Wishlist": "Thêm vào danh sách yêu thích",
    "Additional Information": "Thông tin thêm",
    "All Orders": "Tất cả đơn hàng",
    "Allow order notifications": "Cho phép thông báo đơn hàng",
    "Apply": "Áp dụng",
    "Applied Coupon": "Mã giảm giá đã áp dụng",
    "Attention!": "Chú ý!",
    "Back to home": "Trở về trang chủ",
    "Back to homepage": "Trở về trang chủ",
    "Billing": "Thanh toán",
    "Billing address": "Địa chỉ thanh toán",
    "Brand": "Thương hiệu",
    "Cancel": "Hủy bỏ",
    "Cart": "Giỏ hàng",
    "Categories": "Thể loại",
    "Change": "Thay đổi",
    "Change password your account": "If you want to change the password to access your account, enter the following information",
    "Clear all": "Xóa tất cả",
    "Color": "Màu sắc",
    "Commercial information": "và đồng ý nhận thông tin thương mại cá nhân từ thương hiệu qua email",
    "Contact details updated": "Keep your addresses and contact details updated.",
    "Contact us": "Liên hệ với chúng tôi",
    "Continue to billing": "Tiếp tục đến thanh toán",
    "Continue to payment": "Tiếp tục đến thanh toán",
    "Continue to shipping": "Tiếp tục đến giao hàng",
    "Cookies Policy": "Chính sách Cookie",
    "Create an account": "Tạo tài khoản",
    "Customer Reviews": "Đánh giá của khách hàng",
    "Customer service": "Dịch vụ khách hàng",
    "Date": "Ngày",
    "Default Billing Address": "Địa chỉ thanh toán mặc định",
    "Default Shipping Address": "Địa chỉ giao hàng mặc định",
    "Delete": "Xóa",
    "Departments": "Các phòng ban",
    "Description": "Sự miêu tả",
    "Details and status orders": "Kiểm tra chi tiết và trạng thái đơn hàng của bạn trong cửa hàng trực tuyến. Bạn cũng có thể hủy đơn hàng hoặc yêu cầu trả lại.",
    "Discount": "Giảm giá",
    "Done": "Hoàn thành",
    "Download": "Tải xuống",
    "Download all": "Tải xuống tất cả",
    "Edit": "Chỉnh sửa",
    "Email address": "Địa chỉ email",
    "Empty": "Looks like you haven’t added any items to the bag yet. Start shopping to fill it in.",
    "Empty bag": "Empty bag",
    "Enjoy your free account": "Tận hưởng những đặc quyền với tài khoản miễn phí của bạn!",
    "Enter promo code": "Nhập mã khuyến mãi",
    "Feedback": "Phản hồi của bạn rất quan trọng với chúng tôi. Hãy cho chúng tôi biết những gì chúng tôi có thể cải thiện.",
    "Feel free to edit": "Vui lòng chỉnh sửa bất kỳ thông tin nào bên dưới để tài khoản của bạn luôn được cập nhật",
    "Filters": "Bộ lọc",
    "Find out more": "Tìm hiểu thêm",
    "First Name": "Họ và tên",
    "Forgot Password": "Nếu bạn không nhớ mật khẩu, bạn có thể đặt lại.",
    "Forgot Password Modal Email": "Email bạn đang sử dụng để đăng nhập:",
    "forgotPasswordConfirmation": "Cảm ơn! Nếu có tài khoản đã đăng ký với email {0}, bạn sẽ tìm thấy tin nhắn có liên kết đặt lại mật khẩu trong hộp thư đến của mình.",
    "Forgotten password?": "Quên mật khẩu?",
    "Go back": "Quay lại",
    "Go back shopping": "Tiếp tục mua sắm",
    "Go back to shop": "Quay lại cửa hàng",
    "Go to checkout": "Đi đến thanh toán",
    "Go to cart": "Đi đến giỏ hàng",
    "Guarantee": "Bảo hành",
    "Help": "Trợ giúp",
    "Help & FAQs": "Trợ giúp & Câu hỏi thường gặp",
    "hide": "ẩn",
    "Home": "Trang chủ",
    "I agree to": "Tôi đồng ý với",
    "I confirm subscription": "Tôi xác nhận đăng ký",
    "I want to create an account": "Tôi muốn tạo tài khoản",
    "Info after order": "Bạn có thể đăng nhập vào tài khoản của mình bằng email và mật khẩu đã xác định trước đó. Trên tài khoản của mình, bạn có thể chỉnh sửa dữ liệu hồ sơ, kiểm tra lịch sử giao dịch, chỉnh sửa đăng ký nhận bản tin.",
    "Instruction1": "Hướng dẫn chăm sóc",
    "Instruction2": "Bạn chỉ đến đây để xem hướng dẫn chăm sóc?",
    "Instruction3": "Vâng, chúng tôi hiểu điều đó",
    "It was not possible to request a new password, please check the entered email address.": "Không thể yêu cầu mật khẩu mới, vui lòng kiểm tra địa chỉ email đã nhập.",
    "Item": "Mặt hàng",
    "Items": "Mặt hàng",
    "Kidswear": "Thời trang trẻ em",
    "Last Name": "Họ",
    "Let’s start now – we’ll help you": "Hãy bắt đầu ngay - chúng tôi sẽ giúp bạn.",
    "Log into your account": "Đăng nhập vào tài khoản của bạn",
    "Login": "Đăng nhập",
    "login in to your account": "login in to your account",
    "Looks like you haven’t added any items to the bag yet. Start shopping to fill it in.": "Có vẻ như bạn chưa thêm bất kỳ mặt hàng nào vào giỏ. Hãy bắt đầu mua sắm để thêm vào.",
    "Looks like you haven’t added any items to the Wishlist.": "Có vẻ như bạn chưa thêm bất kỳ mặt hàng nào vào danh sách yêu thích.",
    "Make an order": "Đặt hàng",
    "Manage addresses": "Quản lý tất cả các địa chỉ bạn muốn (nơi làm việc, địa chỉ nhà...) Bằng cách này, bạn sẽ không phải nhập địa chỉ thủ công với mỗi đơn đặt hàng.",
    "Manage billing addresses": "Quản lý tất cả các địa chỉ thanh toán bạn muốn (nơi làm việc, địa chỉ nhà...) Bằng cách này, bạn sẽ không phải nhập địa chỉ thanh toán thủ công với mỗi đơn đặt hàng.",
    "Manage shipping addresses": "Quản lý tất cả các địa chỉ giao hàng bạn muốn (nơi làm việc, địa chỉ nhà...) Bằng cách này, bạn sẽ không phải nhập địa chỉ giao hàng thủ công với mỗi đơn đặt hàng.",
    "Match it with": "Kết hợp với",
    "Men fashion": "Thời trang nam",
    "Menu": "Menu",
    "My billing and shipping address are the same": "Địa chỉ thanh toán và giao hàng của tôi giống nhau",
    "My Cart": "Giỏ hàng của tôi",
    "No account": "Chưa có tài khoản?",
    "or": "hoặc",
    "or fill the details below": "hoặc điền vào các chi tiết bên dưới",
    "Order ID": "ID đơn hàng",
    "Order information": "Thông tin đơn hàng",
    "Order No.": "Order No.",
    "Order summary": "Tóm tắt đơn hàng",
    "Other products you might like": "Những sản phẩm khác bạn có thể thích",
    "Out of stock": "Hết hàng",
    "Password": "Mật khẩu",
    "Password Changed": "Mật khẩu đã được thay đổi thành công. Bạn có thể quay lại trang chủ và đăng nhập.",
    "Pay for order": "Thanh toán đơn hàng",
    "Payment": "Thanh toán",
    "Payment & Delivery": "Thanh toán & Giao hàng",
    "Payment Method": "Phương thức thanh toán",
    "Payment Methods": "Phương thức thanh toán",
    "Personal details": "Thông tin cá nhân",
    "Please type your current password to change your email address.": "Vui lòng nhập mật khẩu hiện tại để thay đổi địa chỉ email của bạn.",
    "Price": "Giá tiền",
    "Privacy": "Quyền riêng tư",
    "Privacy Policy": "Chính sách bảo mật",
    "Product": "Sản phẩm",
    "Product suggestions": "Đề xuất sản phẩm",
    "Products": "Các sản phẩm",
    "Products found": "Sản phẩm được tìm thấy",
    "Purchase terms": "Điều khoản mua hàng",
    "Quality in the details": "Chất lượng trong từng chi tiết",
    "Quantity": "Số lượng",
    "Read all reviews": "Đọc tất cả đánh giá",
    "Read and understand": "Tôi đã đọc và hiểu",
    "Read reviews": "Đọc các bài đánh giá",
    "Register": "Đăng ký",
    "Register today": "Đăng ký ngay hôm nay",
    "Remove": "Xóa",
    "Remove Address": "Xóa địa chỉ",
    "Remove from Wishlist": "Xóa khỏi danh sách yêu thích",
    "Repeat Password": "Nhập lại mật khẩu",
    "Reset Password": "Đặt lại mật khẩu",
    "Review my order": "Xem lại đơn hàng của tôi",
    "Same as shipping address": "Giống như địa chỉ giao hàng",
    "Save changes": "Lưu thay đổi",
    "Save for later": "Tiết kiệm cho sau này",
    "Save Password": "Lưu mật khẩu",
    "Search": "Tìm kiếm",
    "Search for items": "Tìm kiếm mặt hàng",
    "Search results": "Kết quả tìm kiếm",
    "Sections that interest you": "Các mục bạn quan tâm",
    "See all results": "Xem tất cả kết quả",
    "See more": "Xem thêm",
    "Select payment method": "Chọn phương thức thanh toán",
    "Select shipping method": "Chọn phương thức vận chuyển",
    "Send my feedback": "Gửi phản hồi của tôi",
    "Set up newsletter": "Thiết lập bản tin của bạn và chúng tôi sẽ gửi cho bạn thông tin về sản phẩm mới và xu hướng từ các phần bạn đã chọn mỗi tuần.",
    "Share your look": "Chia sẻ phong cách của bạn",
    "Shipping": "Đang chuyển hàng",
    "Shipping address": "Địa chỉ giao hàng",
    "Shipping details": "Chi tiết vận chuyển",
    "Shipping method": "Phương pháp vận chuyển",
    "Show":"Hiển thị",
    "show more": "xem thêm",
    "Show on page": "Hiển thị trên trang",
    "Sign in": "Đăng nhập",
    "Size guide": "Gợi ý tìm size",
    "Sign Up for Newsletter": "Đăng ký nhận bản tin",
    "Sort by": "Sắp xếp theo",
    "Sort: Default": "Mặc định",
    "Sort: Name A-Z": "Tên A-Z",
    "Sort: Name Z-A": "Tên Z-A",
    "Sort: Price from high to low": "Giá từ cao đến thấp",
    "Sort: Price from low to high": "Giá từ thấp đến cao",
    "Start shopping": "Bắt đầu mua sắm",
    "Status": "Trạng thái",
    "Subscribe": "Đăng ký",
    "Subscribe to newsletter": "Đăng ký nhận bản tin",
    "subscribeToNewsletterModalContent": "Sau khi đăng ký nhận bản tin, bạn sẽ nhận được các ưu đãi đặc biệt và tin nhắn từ VSF qua email. Chúng tôi sẽ không bán hoặc phân phối email của bạn cho bất kỳ bên thứ ba nào vào bất kỳ lúc nào. Vui lòng xem {0} của chúng tôi.",
    "Subtotal": "Tổng phụ",
    "Subtotal price": "Giá tổng phụ",
    "Successful placed order": "Bạn đã đặt hàng thành công. Bạn có thể kiểm tra trạng thái đơn hàng bằng cách sử dụng tính năng trạng thái giao hàng của chúng tôi. Bạn sẽ nhận được email xác nhận đơn hàng với chi tiết về đơn hàng và liên kết để theo dõi tiến trình của nó.",
    "Terms and conditions": "Điều khoản và điều kiện",
    "Thank you": "Cảm ơn bạn",
    "Thank You Inbox": "Nếu tin nhắn không đến hộp thư đến của bạn, hãy thử một địa chỉ email khác mà bạn có thể đã sử dụng để đăng ký.",
    "Total": "Toàn bộ",
    "Order Total": "Tổng đơn hàng",
    "Total items": "Tổng số mặt hàng",
    "Total price": "Tổng giá",
    "Update password": "Cập nhật mật khẩu",
    "Update personal data": "Cập nhật thông tin tài khoản",
    "Use your personal data": "Tại Thương hiệu, chúng tôi rất coi trọng vấn đề quyền riêng tư và cam kết bảo vệ dữ liệu cá nhân của người dùng. Tìm hiểu thêm về cách chúng tôi chăm sóc và sử dụng dữ liệu cá nhân của bạn trong",
    "User Account": "Tài khoản người dùng",
    "View": "Xem",
    "View details": "Xem chi tiết",
    "Vue Storefront Next": "Vue Storefront Next",
    "Who we are": "Chúng tôi là ai",
    "Wishlist": "Danh sách yêu thích",
    "Women fashion": "Thời trang nữ",
    "You added {product} to your shopping cart.": "Bạn đã thêm {product} vào giỏ hàng.",
    "You are not authorized, please log in": "Bạn chưa được ủy quyền, vui lòng đăng nhập",
    "You can unsubscribe at any time": "Bạn có thể hủy đăng ký bất kỳ lúc nào",
    "You currently have no orders": "Hiện tại bạn không có đơn đặt hàng nào",
    "You haven\’t searched for items yet": "Bạn chưa tìm kiếm mặt hàng nào.",
    "Your bag is empty": "Giỏ hàng của bạn đang trống",
    "Your current email address is": "Địa chỉ email hiện tại của bạn là",
    "Your email": "Email của bạn",
    "The email field must be a valid email":"Địa chỉ email không hợp lệ",
    'You have submitted no reviews': 'Bạn chưa gửi đánh giá nào',
    "The account sign-in was incorrect or your account is disabled temporarily. Please wait and try again later.":"Thông tin đăng nhập tài khoản không chính xác hoặc tài khoản của bạn tạm thời bị vô hiệu hóa. Vui lòng đợi và thử lại sau.",
    "A customer with the same email address already exists in an associated website.": "Khách hàng với cùng địa chỉ email đã tồn tại trong trang web liên kết.",
    "Invalid email": "Email không hợp lệ",
    "SUMMER COLLECTION {year}": "BỘ SƯU TẬP HÈ {year}",
    "Colorful summer dresses are already in store": "Những chiếc váy hè rực rỡ đã có mặt tại cửa hàng",
    "Learn more": "Tìm hiểu thêm",
    "Dresses": "Váy",
    "Cocktail & Party": "Váy dạ hội & tiệc",
    "Linen Dresses": "Váy vải lanh",
    "T-Shirts": "Áo thun",
    "The office life": "Thời trang văn phòng",
    "Find stunning women's cocktail dresses and party dresses. Stand out in lace and metallic cocktail dresses from all your favorite brands.": "Khám phá những chiếc váy dạ hội và váy dự tiệc phụ nữ tuyệt đẹp. Nổi bật với váy dạ hội ren và kim loại từ tất cả các thương hiệu yêu thích của bạn.",
    "Shop now": "Mua ngay",
    "The Office Life": "Thời trang văn phòng",
    "Summer Sandals": "Dép mùa hè",
    "Eco Sandals": "Dép thân thiện môi trường",
    "Subscribe to Newsletters": "Đăng ký bản tin",
    "Be aware of upcoming sales and events. Receive gifts and special offers!": "Hãy nhận biết về các đợt bán hàng và sự kiện sắp tới. Nhận quà tặng và ưu đãi đặc biệt!",
    "Fashion to take away": "Thời trang mang đi",
    "Download our application to your mobile": "Tải ứng dụng của chúng tôi về điện thoại di động của bạn",
    "Share Your Look": "Chia sẻ cái nhìn của bạn",
    "My Account": "Tài khoản của tôi",
    "My profile": "Thông tin của tôi",
    "Personal Details": "Thông tin cá nhân",
    "Addresses details": "Chi tiết địa chỉ",
    "My newsletter": "Bản tin của tôi",
    "Log out": "Đăng xuất",
    "My reviews": "Đánh giá của tôi",
    "Order history": "Lịch sử đơn hàng",
    "Order details": "Chi tiết đơn hàng",
    "My wishlist": "Danh sách yêu thích của tôi",
    "Password change": "Thay đổi mật khẩu",
    "Your e-mail": "Email của bạn",
    "Current Password": "Mật khẩu hiện tại",
    "You are not authorized, please log in.": "Vui lòng đăng nhập.",
    "Go To Product": "Đi đến sản phẩm",
    "Change to list view": "Chuyển sang chế độ xem danh sách",
    "Change to grid view": "Chuyển sang chế độ xem lưới",
    "Returns":"Quay lại",
    "My orders": "Đơn hàng của tôi",
    "Add the address": "Thêm địa chỉ",
    "Set as default shipping": "Đặt làm địa chỉ giao hàng mặc định",
    "Set as default billing": "Đặt làm địa chỉ thanh toán mặc định",
    "House/Apartment number": "Số nhà / căn hộ",
    "Street Name": "Tên đường",
    "City": "Thành phố",
    "State/Province": "Thành phố / Tỉnh",
    "Zip-code": "Mã Bưu Chính",
    "Country": "Quốc gia",
    "Phone number": "Số điện thoại",
    "Please select a country first":"Vui lòng chọn quốc gia trước",
    "This field is required": "Trường này là bắt buộc",
    "The field should have at least 2 characters": "Trường này phải có ít nhất 2 ký tự",
    "The field should have at least 4 characters": "Trường này phải có ít nhất 4 ký tự",
    "The field should have at least 8 characters": "Trường này phải có ít nhất 8 ký tự",
    "New Password": "Mật khẩu mới",
    "New Products": "Hàng mới",
    "There are no shipping methods available for this country. We are sorry, please try with different country.": "Không có phương thức vận chuyển nào cho quốc gia này. Chúng tôi rất tiếc, vui lòng thử với quốc gia khác.",
    "There was some error while trying to fetch shipping methods. We are sorry, please try with different shipping details.": "Có lỗi khi cố gắng lấy phương thức vận chuyển. Chúng tôi rất tiếc, vui lòng thử với thông tin vận chuyển khác.",
    "There was some error while trying to select this shipping method. We are sorry, please try with different shipping method.": "Có lỗi khi cố gắng chọn phương thức vận chuyển này. Chúng tôi rất tiếc, vui lòng thử với phương thức vận chuyển khác.",
    "We can't find products matching the selection.":"Chúng tôi không thể tìm thấy sản phẩm phù hợp với lựa chọn.",
    'Page not found': 'Không tìm thấy trang',
    'Back to Home page': 'Trở về trang chủ',
    'An error occurred': 'Đã xảy ra lỗi',
    "AllProductsFromCategory": "Tất cả {categoryName}",
    "Show more": "Xem thêm",
    "Show less": "Ẩn bớt",
    "Yes": "Có",
    "No": "Không",
    "Apply filters": "Áp dụng bộ lọc",
    "The coupon code isn't valid. Verify the code and try again.": "Mã giảm giá không đúng. Vui lòng kiểm tra mã và thử lại.",
    "From": "Từ",
    "To": "Đến",
    "Your customization": "Tùy chỉnh của bạn",
    "Passwords don't match":"Mật khẩu không khớp",
    "The password must be at least 8 characters long and must contain at least: 1 uppercase or lowercase letter, 1 number, or one special character (E.g. , . _ & ? etc)":"Mật khẩu phải có ít nhất 8 ký tự và phải chứa ít nhất: 1 chữ hoa hoặc chữ thường, 1 số, hoặc một ký tự đặc biệt (Ví dụ: , . _ & ? v.v.)",
    "Show all products":"Hiển thị tất cả sản phẩm",
    "Select previously saved address":"Chọn địa chỉ đã lưu trước đó",
    "Enter different address":"Nhập địa chỉ khác",
    "You must confirm your account. Please check your email for the confirmation link.": "Bạn phải xác nhận tài khoản của mình. Vui lòng kiểm tra email để tìm liên kết xác nhận.",
    "Change Store":"Đổi cửa hàng",
    "Choose Currency":"Chọn tiền tệ",
    "Add a review":"Thêm đánh giá",
    "Add to cart":"Thêm vào giỏ",
    "Title":"Tiêu đề",
    "Name":"Tên",
    "Review":"Đánh giá",
    "Add review":"Thêm đánh giá",
    "Are you sure you would like to remove this item from the shopping cart?":"Bạn có chắc chắn muốn xóa mặt hàng này khỏi giỏ hàng không?",
    "Your cart is empty":"Giỏ hàng của bạn đang trống",
    "Are you sure?":"Bạn có chắc không?",
    "{0} has been successfully removed from your cart":"{0} đã được xóa thành công khỏi giỏ hàng",
    "Product edit successful: {0}": "Chỉnh sửa sản phẩm thành công: {0}",
    "Amount":"Số lượng",
    "Thank you for your order!":"Cảm ơn bạn đã đặt hàng!",
    "Your Purchase":"Đơn hàng của bạn",
    "Primary contacts for any questions":"Liên hệ chính cho mọi thắc mắc",
    "Your Account":"Tài khoản của bạn",
    "What can we improve":"Những gì chúng tôi có thể cải thiện",
    "Payment date":"Ngày thanh toán",
    "The user password was changed successfully updated!":"Mật khẩu người dùng đã được cập nhật thành công!",
    "The user account data was successfully updated!":"Cập nhật thành công!",
    "You submitted your review for moderation.": "Bạn đã gửi đánh giá để kiểm duyệt.",
    "Starting at": "Bắt đầu từ",
    /* eslint-disable */
    "Error placing an order. The requested Payment Method is not available.": "Lỗi khi đặt hàng. Phương thức Thanh toán được yêu cầu không khả dụng",
    "Some of the ordered products are not available!": "Một số sản phẩm đã đặt hàng không có sẵn!",
    "Error while adding products. The 1427 Cart doesn't contain the 2762 item.": "Error while adding products. The 1427 Cart doesn't contain the 2762 item.",
    "Error placing an order. Some of the products are out of stock.": "Lỗi khi đặt hàng. Một số sản phẩm đã hết hàng.",
    "No such entity with cartId": "Lấy thông tin giỏ hàng không thành công",
    "The requested qty is not available": "Sản phẩm đã hết hàng",
    "is out of stock!": "không đủ số lượng có sẵn!",
    "Could not apply coupon code": "Áp dụng mã giảm giá không thành công",
    "Cash on delivery": "Thanh toán tiền mặt khi nhận hàng - COD",
    "No Payment Information Required": "Không yêu cầu phương thức thanh toán",
    "processing": "Đang xử lý",
    "Discount Codes/Gift Cards": "Mã giảm giá/ Thẻ quà tặng",
    "Processing": "Đang xử lý",
    "Business hours": "Giờ mở cửa",
    "canceled": "Đã hủy",
    "Canceled": "Đã hủy",
    "pending": "Đang chờ xét",
    "Pending": "Đang chờ xét",
    "OTP Expire": "Mã OTP đã hết hạn",
    "List of msisdn contain wrong msisdn": "Số điện thoại không đúng.",
    "You're logged out": "Đăng xuất thành công!",
    "You are logged in!": "Đăng nhập thành công!",
    "Please click CONTINUE": "Vui lòng bấm TIẾP TỤC",
    "to complete the shipping address information": "để hoàn tất thông tin địa chỉ giao hàng",
    "Your coupon is not valid": "Mã giảm giá không đúng.",
    "The coupon code isn't valid. Verify the code and try again.": "Mã giảm giá không đúng.",
    "The coupon code isn't valid. Verify the code and try again": "Mã giảm giá không đúng.",
    "You cant use point exceed of order total": "Bạn không thể sử dụng điểm vượt quá tổng số tổng tiền thanh toán",
    "Your C Point has been locked and can not use now. Please complete another transaction and try again": "Điểm C Point của bạn đã bị khóa và không thể sử dụng ngay bây giờ. Vui lòng hoàn thành một giao dịch khác và thử lại",
    "Product that you are trying to add is not available.": "Sản phẩm đang hết hàng.",
    "There are no source items with the in stock status": "Sản phẩm đang hết hàng",
    "You need to choose options for your item.": "Vui lòng chọn kích cỡ và màu sắc.",
    "Account data has successfully been updated": "Dữ liệu tài khoản đã được cập nhật thành công",
    "A customer with the same email already exists in an associated website.": "A customer with the same email already exists in an associated website.",
    "About us (Magento CMS)": "About us (Magento CMS)",
    "About us": "Giới thiệu",
    "Add a discount code": "Add a discount code",
    "Add discount code": "Apply",
    "Apply": "Áp dụng",
    "Total payment": "Tổng tiền thanh toán",
    "Cost": "Giá gốc",
    "Specify the recipient address. Up to 50 characters": "Ghi rõ địa chỉ người nhận. Tối đa 50 ký tự",
    "Specify the recipient address. Up to 100 characters": "Ghi rõ địa chỉ người nhận. Tối đa 100 ký tự",
    "Add to cart": "Thêm vào giỏ hàng",
    "Add to compare": "Add to compare",
    "Add to favorite": "Thêm vào yêu thích",
    "Additional Information": "Thông tin thêm",
    "Amount": "Số lượng",
    "Allow notification about the order": "Cho phép thông báo về đơn đặt hàng",
    "Are you sure you would like to remove all the items from the shopping cart?": "Bạn có chắc chắn muốn xóa tất cả các mặt hàng khỏi giỏ hàng không?",
    "Are you sure you would like to remove all the items from the wishlist?": "Bạn có chắc chắn muốn xóa tất cả các mục khỏi danh sách yêu thích không?",
    "Author": "Quyền",
    "Authorization in progress ...": "Đang tiến hành ủy quyền ...",
    "Back to login": "Quay lại đăng nhập",
    "Back": "Quay lại",
    "Billing address": "Địa chỉ thanh toán",
    "Cancel": "Hủy bỏ",
    "Cash on delivery": "Thanh toán khi giao hàng",
    "Categories": "Thể loại",
    "Change my password": "Thay đổi mật khẩu",
    "Changed your mind?": "Changed your mind?",
    "Choose your country": "Chọn quốc gia của bạn",
    "City *": "Thành phố *",
    "City": "Thành phố",
    "Clear all": "Xóa tất cả",
    "Clear cart": "Xóa sản phẩm trong giỏ hàng",
    "Clear filters": "Xóa bộ lọc",
    "Clear wishlist": "Xóa sản phẩm mong muốn",
    "Clear": "Xóa",
    "Close": "Đóng",
    "Cms Page Sync": "Đồng bộ hóa trang Cms",
    "Colour": "Màu sắc",
    "Columns": "Cột",
    "Company name *": "Tên công ty *",
    "Company name": "Tên công ty",
    "Compare products": "So sánh sản phẩm",
    "Confirm your order": "Xác nhận đơn đặt hàng của bạn",
    "Contact us": "Liên hệ",
    "Contact": "Liên hệ",
    "Continue to payment": "Tiếp tục thanh toán",
    "Continue to shipping": "Tiếp tục chuyển hàng",
    "Copy address data from shipping": "Sao chép dữ liệu từ địa chỉ giao hàng",
    "Country *": "Quốc gia *",
    "Country": "Quốc gia",
    "Create a new account": "Tạo tài khoản mới",
    "Current password *": "Mật khẩu hiện tại *",
    "Custom Cms Page": "Custom Cms Page",
    "Customer service (Magento CMS)": "Customer service (Magento CMS)",
    "Customer service": "Customer service",
    "DPD Courier": "DPD Courier",
    "Date and time": "Date and time",
    "Delivery": "Chính sách vận chuyển",
    "Loyalty Policy": "Chính sách KHTT",
    "Conditions - Terms and Conditions Policy": "Điều kiện - Điều khoản Chính sách KHTT",
    "Departments": "Các phòng ban",
    "Description": "Sự miêu tả",
    "Discount code": "Mã giảm giá",
    "Don't hesitate and": "Don't hesitate and",
    "Done": "Hoàn thành",
    "E-mail address *": "Địa chỉ E-mail *",
    "E-mail us at <b>demo@vuestorefront.io</b> with any questions, suggestions how we could improve products or shopping exrience": "E-mail us at <b>demo@vuestorefront.io</b> with any questions, suggestions how we could improve products or shopping exrience",
    "Earn credits with every purchase": "Thêm tín dụng với mỗi lần mua hàng",
    "Easy shipping": "Vận chuyển dễ dàng",
    "Edit newsletter preferences": "Chỉnh sửa tùy chọn bản tin",
    "Edit payment": "Chỉnh sửa thanh toán",
    "Edit personal details": "Chỉnh sửa thông tin cá nhân",
    "Edit shipping": "Chỉnh sửa giao hàng",
    "Edit your profile": "Chỉnh sửa hồ sơ của bạn",
    "Edit your shipping details": "Chỉnh sửa chi tiết điều khoản giao hàng của bạn",
    "Edit": "Chỉnh sửa",
    "Email address *": "Địa chỉ email *",
    "Email address": "Địa chỉ email",
    "English": "Tiếng anh",
    "Enjoy these perks with your free account!": "Tận hưởng những đặc quyền này với tài khoản miễn phí của bạn!",
    "Enter your email to receive instructions on how to reset your password.": "Nhập email của bạn để nhận hướng dẫn về cách đặt lại mật khẩu.",
    "Erin recommends": "Erin khuyến nghị",
    "Error while sending reset password e-mail": "Lỗi khi gửi e-mail đặt lại mật khẩu",
    "Everything new": "Mọi thứ mới",
    "Extension developers would like to thank you for placing an order!": "Các nhà phát triển tiện ích muốn cảm ơn bạn đã đặt hàng!",
    "Faster checkout": "Thanh toán nhanh hơn",
    "Field is required": "Trường này là bắt buộc",
    "Filter by categories": "Lọc theo danh mục",
    "Filter": "Lọc",
    "Filters": "Bộ lọc",
    "First name *": "Tên của bạn *",
    "First name": "Tên của bạn",
    "Forgot the password?": "Quên mật khẩu?",
    "Full rewards program benefits": "Đầy đủ các lợi ích của chương trình phần thưởng ",
    "General agreement": "Thỏa thuận chung",
    "German": "Tiếng Đức",
    "Germany": "Nước Đức",
    "Get inspired": "Get inspired",
    "Give a feedback": "Đưa ra phản hồi",
    "Go review the order": "Xem lại đơn đặt hàng",
    "Go to Facebook": "Đi tới Facebook",
    "Go to Instagram": "Đi tới Instagram",
    "Go to Pinterest": "Đi tới Pinterest",
    "Go to Youtube": "Đi tới Youtube",
    "Go to checkout": "Đi tới checkout",
    "Help": "Giúp đỡ",
    "Hide products": "Ẩn sản phẩm",
    "Home": "Trang chủ",
    "House/Apartment number *": "House/Apartment number *",
    "House/Apartment number": "House/Apartment number",
    "I accept ": "Tôi chấp nhận ",
    "I accept terms and conditions": "Tôi chấp nhận các điều khoản và điều kiện",
    "I agree to": "Tôi đồng ý",
    "I have a company and want to receive an invoice for every order": "Tôi có một công ty và muốn nhận hóa đơn cho mọi đơn hàng",
    "I want to create an account": "Tôi muốn lập một tài khoản",
    "I want to create an account'": "Tôi muốn lập một tài khoản",
    "I want to generate an invoice for the company": "Tôi muốn tạo hóa đơn cho công ty",
    "I want to receive a newsletter, and agree to its terms": "Tôi muốn nhận một bản tin và đồng ý với các điều khoản",
    "If you need an assistance you can drop us a line on": "Nếu bạn cần hỗ trợ, bạn có thể liên hệ với chúng tôi",
    "Instant Checkout": "Thanh toán tức thì",
    "Internal Server Error 500": "Internal Server Error 500",
    "It carefully packaged with a personal touch": "Nó được đóng gói cẩn thận với một liên lạc cá nhân",
    "Italian": "Italian",
    "Italy": "Italy",
    "Item": "Item",
    "Items ordered": "Mục thứ tự",
    "Kidswear": "Quần áo trẻ em",
    "Last name *": "Họ *",
    "Last name": "Họ",
    "Latest": "Muộn nhất",
    "Legal notice": "Thông báo pháp lý",
    "Load more": "Xem thêm",
    "Log in to your account": "Đăng nhập vào tài khoản của bạn",
    "Log in": "Đăng nhập",
    "Login to your account": "Đăng nhập vào tài khoản của bạn",
    "Logout": "Đăng xuất",
    "Magazine": "Tạp chí",
    "Manage your wishlist": "Quản lý danh sách yêu thích của bạn",
    "Men's fashion": "Thời trang nam",
    "My Account": "Tài khoản của tôi",
    "My Recently viewed products": "Các sản phẩm đã xem gần đây của tôi",
    "My account": "Tài khoản của tôi",
    "My loyalty card": "Thẻ khách hàng thân thiết của tôi",
    "My newsletter": "Bản tin của tôi",
    "My orders": "Đơn đặt hàng của tôi",
    "My product reviews": "Đánh giá sản phẩm của tôi",
    "My profile": "Thông tin của tôi",
    "My shipping details": "Chi tiết giao hàng của tôi",
    "Name must have at least 2 letters.": "Tên phải có ít nhất 2 chữ cái.",
    "Name must have at least 3 letters.": "Tên phải có ít nhất 3 chữ cái.",
    "New Luma Yoga Collection": "Bộ sưu tập Luma Yoga mới",
    "New password *": "Mật khẩu mới *",
    "Newsletter": "Bản tin",
    "No orders yet": "Chưa có đơn đặt hàng",
    "No products found!": "Không tìm thấy sản phẩm!",
    "No products yet": "Chưa có sản phẩm nào",
    "No results were found.": "Không tìm thây kêt quả.",
    "No reviews have been posted yet. Please don't hesitate to share Your opinion and write the first review!": "Chưa có đánh giá đã được đăng lên chưa. Xin đừng ngần ngại chia sẻ ý kiến ​​của bạn và viết đánh giá đầu tiên!",
    "OK": "OK",
    "Open menu": "Mở Menu",
    "Open microcart": "Open microcart",
    "Open my account": "Open my account",
    "Open search panel": "Open search panel",
    "Open wishlist": "Open wishlist",
    "Order #{id}": "Order #{id}",
    "Order details": "Chi tiết đơn hàng",
    "Order ID": "ID đơn hàng",
    "Order review": "Xem xét đơn hàng",
    "Order Summary": "Tóm tắt đơn hàng",
    "Order confirmation": "Xác nhận đơn hàng",
    "Order informations": "Thông tin đặt hàng",
    "Orders": "Đơn hàng",
    "Others": "Khác",
    "Password *": "Mật khẩu *",
    "Password must have at least 8 letters.": "Mật khẩu phải có ít nhất 8 chữ cái.",
    "Passwords must be identical": "Mật khẩu phải giống nhau",
    "Passwords must be identical.": "Mật khẩu phải giống nhau.",
    "Password must contain at least 3 different character classes: lower case, upper case, digits, special characters.": "Mật khẩu phải chứa ít nhất 3 lớp ký tự khác nhau: chữ thường, chữ hoa, chữ số, ký tự đặc biệt.",
    "Payment method": "Phương thức thanh toán",
    "Payment": "Thanh toán",
    "Personal Details": "Thông tin cá nhân",
    "Phone Number": "Số điện thoại",
    "Phone number may be needed by carrier": "Số điện thoại cần thiết cho giao hàng",
    "Place the order": "Đặt hàng",
    "Please change Your search criteria and try again. If still not finding anything relevant, please visit the Home page and try out some of our bestsellers!": "Vui lòng thay đổi tiêu chí tìm kiếm của bạn và thử lại. Nếu vẫn không tìm thấy bất kỳ điều gì có liên quan, vui lòng truy cập Trang chủ và thử một phần bán chạy nhất của chúng tôi!",
    "Please check if all data are correct": "Vui lòng kiểm tra xem tất cả dữ liệu có chính xác không",
    "Please confirm order you placed when you was offline": "Vui lòng xác nhận đơn hàng bạn đã đặt khi bạn ngoại tuyến",
    "Please provide valid e-mail address.": "Vui lòng cung cấp địa chỉ e-mail hợp lệ.",
    "Please provide valid phone number": "Vui lòng cung cấp số điện thoại hợp lệ.",
    "Price {variant}": "Giá {biến}",
    "Price": "Giá tiền",
    "Price: High to low": "Giá: Cao đến thấp",
    "Price: Low to high": "Giá: Thấp đến cao",
    "Product {productName} has been removed from wishlist!": "Sản phẩm {productName} đã bị xóa khỏi danh sách yêu thích!",
    "Product {productName} has been added to wishlist!": "Sản phẩm {productName} đã được thêm vào danh sách yêu thích!",
    "Privacy policy": "Chính sách bảo mật thông tin KH",
    "Product Name": "Tên sản phẩm",
    "Product details": "Thông tin chi tiết sản phẩm",
    "Products": "Các sản phẩm",
    "Products found": "Sản phẩm được tìm thấy",
    "Purchase": "Mua",
    "Qty": "Qty",
    "Quantity": "Số lượng",
    "Register an account": "Đăng ký tài khoản",
    "Register": "Đăng ký",
    "Remake order": "Đặt hàng lại",
    "Remember me": "Nhớ tài khoản",
    "Remove from compare": "Xóa khỏi danh sách so sánh",
    "Remove": "Xóa",
    "Successfully applied discount code": "Áp dụng thành công mã giảm giá",
    "The discount code is incorrect or expired.": "Mã giảm giá không đúng hoặc hết hạn.",
    "Repeat new password *": "Lặp lại mật khẩu mới *",
    "Repeat password *": "Lặp lại mật khẩu *",
    "Repeat password": "Lặp lại mật khẩu",
    "Reset password": "Đặt lại mật khẩu",
    "Resetting the password ... ": "Đặt lại mật khẩu ... ",
    "Rest assured, we offer free returns within 30 days": "Hãy yên tâm, chúng tôi cung cấp trả lại miễn phí trong vòng 30 ngày",
    "Return policy": "Chính sách hoàn trả",
    "Return to shopping": "Quay lại mua sắm",
    "Returns": "Quay lại",
    "Review order": "Xem lại đơn đặt hàng",
    "SKU": "SKU",
    "SKU: {sku}": "SKU: {sku}",
    "Safety": "Sự an toàn",
    "Sale": "Sale",
    "Search": "Tìm kiếm",
    "Searched term should consist of at least 3 characters.": "Cụm từ đã tìm kiếm phải có ít nhất 3 ký tự.",
    "See details": "Xem chi tiết",
    "See our bestsellers": "Xem những phần bán chạy nhất của chúng tôi",
    "Select No": "Chọn Không",
    "Select Yes": "Chọn Có",
    "Select color ": "Chọn màu ",
    "Select size {variant}": "Chọn kích cỡ {variant}",
    "Ship to my default address": "Gửi đến địa chỉ mặc định của tôi",
    "Shipping address": "Địa chỉ giao hàng",
    "Shipping method": "Phương pháp vận chuyển",
    "Shipping": "Đang chuyển hàng",
    "Shopping cart": "Giỏ hàng",
    "Show products": "Hiển thị sản phẩm",
    "Show subcategories": "Hiển thị các danh mục phụ",
    "Sign up to our newsletter and receive a coupon for 10% off!": "Đăng ký nhận bản tin của chúng tôi và nhận phiếu giảm giá 10%!",
    "Similar products": "Sản phẩm liên quan",
    "Size": "Kích cỡ",
    "Social": "Xã hội",
    "Something went wrong ...": "Đã xảy ra sự cố ...",
    "Something went wrong. Try again in a few seconds.": "Đã xảy ra lỗi. Hãy thử lại sau vài giây.",
    "Sort By": "Sắp xếp theo",
    "State / Province": "Thành phố / Tỉnh",
    "Status": "Trạng thái",
    "Store locator": "Công cụ định vị cửa hàng",
    "Street name *": "Tên đường *",
    "Street name": "Tên đường",
    "Subscribe to the newsletter and receive a coupon for 10% off": "Đăng ký nhận bản tin và nhận phiếu giảm giá 10%",
    "Subscribe": "Đặt mua",
    "Subtotal": "Tổng phụ",
    "Tax ID *": "Mã số thuế *",
    "Tax ID must have at least 3 letters.": "Mã số thuế phải có ít nhất 3 chữ cái.",
    "Tax identification number *": "Mã số thuế *",
    "Tax identification number": "Mã số thuế",
    "Tax identification number must have at least 3 letters.": "Mã số thuế phải có ít nhất 3 chữ cái.",
    "Tax": "Thuế",
    "Terms and conditions": "Các điều khoản và điều kiện",
    "The OrderNumber is {id}": "Số Đơn hàng là {id}",
    "The new account will be created with the purchase. You will receive details on e-mail.": "Tài khoản mới sẽ được tạo khi mua hàng. Bạn sẽ nhận được thông tin chi tiết trên e-mail.",
    "The order can not be transfered because of server error. Order has been queued": "Có lỗi xảy ra khi đặt đơn hàng",
    "The server order id has been set to ": "Id đơn đặt hàng của máy chủ đã được đặt thành ",
    "This product is out of stock.": "This product is out of stock.",
    "To finish the order just come back to our store while online. Your order will be sent to the server as soon as you come back here while online and then confirmed regarding the stock quantities of selected items": "Để hoàn tất đơn đặt hàng, chỉ cần quay lại cửa hàng của chúng tôi khi trực tuyến. Đơn đặt hàng của bạn sẽ được gửi đến máy chủ ngay sau khi bạn quay lại đây khi đang trực tuyến và sau đó được xác nhận về số lượng còn lại của các mặt hàng đã chọn",
    "Toggle password visibility": "Chuyển đổi chế độ hiển thị mật khẩu",
    "Track my order": "Theo dõi đơn hàng của tôi",
    "Type your opinion": "Nhập ý kiến ​​của bạn",
    "Type": "Kiểu",
    "Unfortunately we can't find the page you are looking for.": "Rất tiếc, chúng tôi không thể tìm thấy trang bạn đang tìm kiếm.",
    "United States": "Hoa Kỳ",
    "Update my preferences": "Cập nhật tùy chọn của tôi",
    "Update my profile": "Cập nhật hồ sơ của tôi",
    "Update my shipping details": "Cập nhật chi tiết giao hàng của tôi",
    "Use my billing data": "Sử dụng dữ liệu thanh toán của tôi",
    "Use my company's address details": "Sử dụng địa chỉ của công ty tôi",
    "Value": "Giá trị",
    "View": "Quan điểm",
    "View all": "Xem tất cả",
    "View order": "Xem đơn đặt hàng",
    "Vuestore": "Vuestore",
    "We can't find the page": "Chúng tôi không thể tìm thấy trang",
    "We found other products you might like": "Chúng tôi đã tìm thấy các sản phẩm khác mà bạn có thể thích",
    "We use cookies to give you the best shopping experience.": "Chúng tôi sử dụng cookie để mang đến cho bạn trải nghiệm mua sắm tốt nhất.",
    "We will send you details regarding the order": "Chúng tôi sẽ gửi cho bạn thông tin chi tiết về đơn đặt hàng",
    "We will send you the invoice to given e-mail address": "Chúng tôi sẽ gửi cho bạn hóa đơn đến địa chỉ e-mail nhất định",
    "We've noticed Internal Server Error while rendering this request.": "Chúng tôi đã nhận thấy Lỗi máy chủ nội bộ khi hiển thị yêu cầu này.",
    "We've sent password reset instructions to your email. Check your inbox and follow the link.": "Chúng tôi đã gửi hướng dẫn đặt lại mật khẩu đến email của bạn. Kiểm tra hộp thư đến của bạn và theo liên kết.",
    "What we can improve?": "Những gì chúng tôi có thể cải thiện?",
    "Wishlist": "Danh sách yêu thích",
    "Women fashion": "Thời trang nữ",
    "You are logged in as {firstname}": "Bạn đang đăng nhập {firstname}",
    "You are offline": "Bạn đang offline",
    "You are offline. Some features might not be available.": "Bạn đang offline. Một số tính năng có thể không khả dụng.",
    "You can allow us to remind you about the order via push notification after coming back online. You'll only need to click on it to confirm.": "Bạn có thể cho phép chúng tôi nhắc bạn về đơn đặt hàng thông qua thông báo đẩy sau khi trực tuyến trở lại. Bạn chỉ cần nhấp vào nó để xác nhận.",
    "You can also use": "Bạn cũng có thể dùng",
    "You can log to your account using e-mail and password defined earlier. On your account you can <b>edit your profile data,</b> check <b>history of transactions,</b> edit <b>subscription to newsletter.</b>": "Bạn có thể đăng nhập vào tài khoản của mình bằng e-mail và mật khẩu đã xác định trước đó. Trên tài khoản của mình, bạn có thể <b> chỉnh sửa dữ liệu hồ sơ của mình, </b> kiểm tra <b> lịch sử giao dịch, </b> chỉnh sửa <b> đăng ký nhận bản tin. </b>",
    "You have been successfully subscribed to our newsletter!": "Bạn đã đăng ký nhận bản tin của chúng tôi thành công!",
    "You have been successfully unsubscribed from our newsletter!": "Bạn đã được hủy đăng ký nhận bản tin của chúng tôi thành công!",
    "You have no items to compare.": "Bạn không có sản phẩm để so sánh.",
    "You can check status of your order by using our delivery status feature. You will receive an order confirmation e-mail with details of your order and a link to track its progress.": "Bạn có thể kiểm tra trạng thái đơn hàng của mình bằng cách sử dụng tính năng trạng thái giao hàng của chúng tôi. Bạn sẽ nhận được một e-mail xác nhận đơn đặt hàng với các chi tiết về đơn đặt hàng của bạn và một liên kết để theo dõi tiến trình của đơn đặt hàng.",
    "You must accept the terms and conditions.": "Bạn phải chấp nhận các điều khoản và điều kiện.",
    "You will receive Push notification after coming back online. You can confirm the order by clicking on it": "Bạn sẽ nhận được thông báo sau khi trực tuyến trở lại. Bạn có thể xác nhận đơn đặt hàng bằng cách nhấp vào nó",
    "You will receive Push notification about the order.": "Bạn sẽ nhận được thông báo về đơn đặt hàng.",
    "You’ll receive dispatch confirmation and an arrival date": "Bạn sẽ nhận được xác nhận gửi và ngày đến",
    "You've entered an incorrect coupon code. Please try again.": "Bạn đã nhập mã phiếu thưởng không chính xác. Vui lòng thử lại.",
    "Your Account": "Tài khoản của bạn",
    "Your feedback is important for us. Let us know what we could improve.": "Phản hồi của bạn rất quan trọng đối với chúng tôi. Hãy cho chúng tôi biết những gì chúng tôi có thể cải thiện.",
    "Your purchase": "Your purchase",
    "Your wishlist is empty.": "Danh sách sản phẩm yêu thích của bạn đang trống.",
    "Zip-code *": "Mã Bưu Chính *",
    "Zip-code must have at least 3 letters.": "Mã zip phải có ít nhất 3 chữ cái.",
    "Zip-code": "Mã Bưu Chính",
    "a chat": "Một cuộc trò chuyện",
    "a contact page": "Một trang liên hệ",
    "browse our catalog": "Duyệt qua danh mục của chúng tôi",
    "color": "Màu sắc",
    "color_filter": "Màu sắc",
    "erin_recommends_filter": "Erin Recommends",
    "login": "Đăng nhập",
    "or write to us through": "Hoặc viết thư cho chúng tôi thông qua",
    "or": "Hoặc",
    "price_filter": "Khoảng giá",
    "register an account": "Đăng ký một tài khoản",
    "return to log in": "Trở về trang đăng nhập",
    "search": "Tìm kiếm",
    "size": "Kích thước",
    "size_filter": "Kích cỡ",
    "to find product you were looking for.": "Tìm sản phẩm bạn đang tìm kiếm.",
    "to find something beautiful for You!": "Tìm sản phẩm đẹp cho bạn!",
    "{count} items": "{count} mặt hàng",
    "My Cart": "Giỏ hàng của tôi",
    "Your bag is empty": "Giỏ hàng của bạn trống rỗng",
    "Looks like you haven’t added any items to the bag yet. Start shopping to fill it in.": "Có vẻ như bạn chưa thêm bất kỳ mục nào vào giỏ hàng. Bắt đầu mua sắm để thêm vào giỏ hàng.",
    "Start shopping": "Bắt đầu mua sắm",
    "Total items": "Tổng số mặt hàng",
    "Save for later": "Tiết kiệm cho sau này",
    "Total": "Toàn bộ",
    "Your email": "Email của bạn",
    "Password": "Mật khẩu",
    "Forgotten password?": "Quên mật khẩu?",
    "Don't have an account yet?": "Chưa có tài khoản?",
    "Register now": "Đăng ký ngay",
    "Create an account": "Tạo một tài khoản",
    "login in to your account": "Đăng nhập vào tài khoản của bạn",
    "My Account": "Tài khoản",
    "Read all {review} review": "Đọc tất cả bài {review} đánh giá",
    "Shipping details": "Chi tiết vận chuyển",
    "Loyalty Card": "Thẻ thành viên thân thiết",
    "Order details": "Chi tiết đơn hàng",
    "Order history": "Lịch sử đơn hàng",
    "My reviews": "Đánh giá của tôi",
    "Log out": "Đăng xuất",
    "Read all {count} review": "Đọc tất cả bài {count} đánh giá ",
    "{count} Reviews": "{count} Nhận xét",
    "Similar Products": "Sản phẩm liên quan",
    "Description": "Sự miêu tả",
    "Read reviews": "Đọc các bài đánh giá",
    "Leave me review": "Để lại cho tôi xem xét",
    "Personal data": "Thông tin tài khoản",
    "Password change": "Thay đổi mật khẩu",
    "Feel free to edit any of your details below so your account is always up to date": "Vui lòng chỉnh sửa bất kỳ chi tiết nào của bạn bên dưới để tài khoản của bạn luôn được cập nhật",
    "Update personal data": "Cập nhật thông tin tài khoản",
    "At Brand name, we attach great importance to privacy issues and are committed to protecting the personal data of our users. Learn more about how we care and use your personal data in the": "Tại Brand name, chúng tôi rất coi trọng các vấn đề về quyền riêng tư và cam kết bảo vệ dữ liệu cá nhân của người dùng. Tìm hiểu thêm về cách chúng tôi quan tâm và sử dụng dữ liệu cá nhân của bạn trong",
    "Current Password": "Mật khẩu hiện tại",
    "New Password": "Mật khẩu mới",
    "Update password": "Cập nhật mật khẩu",
    "If you want to change the password to access your account, enter the following information:": "Nếu bạn muốn thay đổi mật khẩu để truy cập tài khoản của mình, hãy nhập các thông tin sau:",
    "Your current email address is": "Địa chỉ email hiện tại của bạn là",
    "or login to your account": "Hoặc đăng nhập vào tài khoản của bạn",
    "Change the address": "Thay đổi địa chỉ",
    "Manage all the shipping addresses you want (work place, home address ...) This way you won't have to enter the shipping address manually with each order.": "Quản lý tất cả các địa chỉ giao hàng bạn muốn (địa chỉ cơ quan, địa chỉ nhà riêng ...) Bằng cách này, bạn sẽ không phải nhập địa chỉ giao hàng theo cách thủ công với mỗi đơn đặt hàng.",
    "Add new address": "Thêm địa chỉ mới",
    "Keep your addresses and contact details updated.": "Luôn cập nhật địa chỉ và chi tiết liên hệ của bạn.",
    "Update the address": "Cập nhật địa chỉ",
    "This feature is not implemented yet! Please take a look at": "Tính năng này chưa được triển khai! Mời các bạn xem qua",
    "for our Roadmap!": "cho Lộ trình của chúng tôi!",
    "Check the details and status of your orders in the online store. You can also cancel your order or request a return.": "Kiểm tra chi tiết và trạng thái đơn đặt hàng của bạn trong cửa hàng trực tuyến. Bạn cũng có thể hủy đơn đặt hàng của mình hoặc yêu cầu trả lại.",
    "You currently have no orders": "Bạn hiện không có đơn đặt hàng nào",
    "Best get shopping pronto...": "Best get shopping pronto...",
    "Start shopping": "Bắt đầu mua sắm",
    "Download": "Tải xuống",
    "Download all": "Tải xuống tất cả",
    "VIEW": "VIEW",
    "Homepage": "Trang chủ",
    "Order date": "Ngày đặt hàng",
    "Return to home": "Trở về trang chủ",
    "Street Name": "Tên đường",
    "House/Apartment number": "Số nhà / căn hộ",
    "State/Province": "Thành phố / Tỉnh",
    "Phone number": "Số điện thoại",
    "Delete discount code": "Xóa mã giảm giá",
    "It's ordered!": "Nó được đặt hàng!",
    "Order No.": "Order No.",
    "You've successfully placed the order": "Bạn đã đặt hàng thành công",
    "Allow order notifications": "Cho phép thông báo đơn đặt hàng",
    "Send my feedback": "Gửi phản hồi của tôi",
    "Back to shop": "Quay trở lại cửa hàng",
    "Confirmation of receival": "Xác nhận người nhận",
    "Profile": "Hồ sơ",
    "Cart": "Giỏ hàng",
    "Product suggestions": "Đề xuất sản phẩm",
    "Thumbnail": "Hình nhỏ",
    "Subscribe to Newsletters": "Đăng ký bản tin",
    "Be aware of upcoming sales and events. Receive gifts and special offers!": "Hãy nhận biết về các đợt bán hàng và sự kiện sắp tới. Nhận quà tặng và ưu đãi đặc biệt!",
    "E-mail address": "Địa chỉ email",
    "An error occured while loading the component.": "Đã xảy ra lỗi khi tải thành phần.",
    "Component couldn't be loaded due to lack of network connectivity.": "Không thể tải thành phần do thiếu kết nối mạng.",
    "Try again": "Thử lại",
    "Bestsellers": "Bán chạy nhất",
    "Share Your Look": "Chia sẻ cái nhìn của bạn",
    "or fill the details below": "Hoặc điền vào các chi tiết bên dưới",
    "Details": "Thông tin chi tiết",
    "Review": "Review",
    "Menu": "Menu",
    "Selected variant is out of stock": "Selected variant is out of stock",
    "Support": "Hỗ trợ",
    "Blog": "Tin tức",
    "Recruitment": "Tuyển dụng",
    "Community": "Với cộng đồng",
    "Store Locations": "Hệ thống cửa hàng",
    "Q&A": "Hỏi đáp",
    "Shipping Policy": "Chính sách vận chuyển",
    "Size guide": "Gợi ý tìm size",
    "Check your order": "Kiểm tra đơn hàng",
    "Terms of exchange": "Quy định đổi hàng",
    "Look up card points": "Tra cứu điểm thẻ",
    "Issued by": "Nơi cấp",
    "business code": "Số ĐKKD",
    "Fax": "Fax",
    "Trademark": "Thương hiệu",
    "Download the app on your phone": "Tải ứng dụng trên điện thoại",
    "LET CANIFA SUPPORT YOU": "HÃY ĐỂ CANIFA ĐƯỢC HỖ TRỢ BẠN",
    "Topics of interest": "Chủ đề được quan tâm",
    "Frequently asked questions": "Các câu hỏi thường gặp",
    "Shop search": "Tìm kiếm cửa hàng",
    "Select Province / City": "Lựa chọn Tỉnh / Thành Phố",
    "Select District / District": "Lựa chọn Quận / Huyện",
    "Customer support": "Hỗ trợ khách hàng",
    "Refund Policy": "Quy định đổi trả",
    "Product": "Sản phẩm",
    "Discount": "Giảm giá",
    "Total amount": "Tổng tiền",
    "Continue shopping": "Tiếp tục mua hàng",
    "Gross product": "Tổng sản phẩm",
    "Complete your order": "Hoàn tất đơn hàng",
    "You added": "Bạn đã thêm",
    "To cart": "vào giỏ hàng",
    "Your exclusive offer": "Ưu đãi riêng bạn",
    "NEW PRODUCTS": "HÀNG MỚI",
    "Sign up for the newsletter": "Đăng ký nhận bản tin",
    "Send": "Gửi",
    "Connect now": "Kết nối ngay",
    "Hot deal with great price !": "Deal hot giá hời !",
    "End later": "Kết thúc sau",
    "Confident down the street": "Tự tin xuống phố",
    "Please fix the validation errors": "Vui lòng sửa lỗi xác thực",
    "Product has been added to the cart": "Sản phẩm đã được thêm vào giỏ hàng",
    "You submitted your review for moderation": "Bạn đã gửi đánh giá của mình để được kiểm duyệt",
    "Something went wrong. Try again in a few seconds.": "Đã xảy ra lỗi. Hãy thử lại sau vài giây.",
    "Check your order status": "Kiểm tra tình trạng đơn hàng của bạn",
    "Check": "Kiểm tra",
    "Enter your order number": "Nhập mã đơn hàng",
    "Log in to your account to check your order number": "Đăng nhập vào tài khoản của bạn để kiểm tra mã đơn hàng",
    "Search result": "Kết quả tìm kiếm",
    "store highlight": "CỬA HÀNG NỔI BẬT",
    "Phone number store": "ĐT",
    "history search": "Lịch sử tìm kiếm",
    "provisional": "Tạm Tính",
    "Adding to cart": "Đang thêm vào giỏ hàng",
    "Color": "Màu sắc",
    "ColorDefault": "Màu",
    "Headquarters": "Trụ sở chính",
    "Sales office": "Địa chỉ liên hệ",
    "Log in to your account to view your loyalty": "Đăng nhập vào tài khoản của bạn để tra cứu điểm thẻ",
    "Out of stock!": "Hết hàng!",
    "Add to carts": "Thêm vào giỏ",
    "Products {name} are out of stock, please remove it from cart and try again": "Sản phẩm {name} hết hàng trong giỏ hàng, vui lòng kiểm tra trước khi tiến hành thanh toán.",
    "*Product is out of stock": "*Sản phẩm đã hết hàng",
    "products available": "sản phẩm có sẵn",
    "There only": "Chỉ còn lại",
    "Products {name} are not enough stock, please check it again": "Sản phẩm {name} không đủ số lượng có sẵn, vui lòng kiểm tra lại",
    "Using C-point": "Sử dụng C-point",
    "Number of C-points available": "Số C-point khả dụng",
    "Use": "Sử dụng",
    "Transport fee": "Phí vận chuyển",
    "Information Order": "Thông tin đơn hàng",
    "You have entered too many C Points available!": "Bạn nhập quá số C Point khả dụng!",
    "Checking C Point...": "Đang kiểm tra C Point...",
    "Connection errors!": "Lỗi kết nối!",
    "C Point is not available!": "C Point không khả dụng!",
    "Please enter C Point number!": "Vui lòng nhập số C Point!",
    "Please enter Voucher code!": "Vui lòng nhập mã Voucher!",
    "Deleting C Point...": "Đang xóa C Point ...",
    "Deleting C Point failed!": "Xóa C Point không thành công!",
    "Transport": "Vận chuyển",
    "Shipping There was an error in the shipping charge, please try again later!": "Có lỗi khi tính phí vận chuyển, vui long thử lại sau !",
    "Please enter the required information fields!": "Vui lòng nhập các trường thông tin yêu cầu !",
    "TOPIC OF INTERESTING US": "CHỦ ĐỀ QUAN TÂM",
    "MOST-VIEWED ARTICLES": "BÀI VIẾT XEM NHIỀU NHẤT",
    "RELATED ARTICLES": "BÀI VIẾT LIÊN QUAN",
    "TOPIC OF INTERESTING US": "Kết quả tìm kiếm",
    "Please enter your name": "Vui lòng nhập tên của bạn",
    "Please enter your address": "Vui lòng nhập địa chỉ của bạn",
    "Please enter your phone number": "Vui lòng nhập số điện thoại của bạn",
    "Please select a city": "Vui lòng chọn tỉnh/thành phố",
    "Please select District": "Vui lòng chọn Quận/Huyện",
    "Please select Ward/Commune": "Vui lòng chọn Phường/Xã",
    "Please enter the name of the consignee!": "Vui lòng nhập họ tên người nhận hàng!",
    "Please do not enter special characters!": "Vui lòng không nhập ký tự đặc biệt!",
    "Please enter consignee phone number!": "Vui lòng nhập số điện thoại người nhận hàng!",
    "Incorrect phone number!": "Số điện thoại không đúng!",
    "Please enter your shipping address!": "Vui lòng nhập địa chỉ giao hàng!",
    "The address is incorrect!": "Địa chỉ không đúng!",
    "Shipment Details": "Thông tin giao hàng",
    "Save changes": "Lưu thay đổi",
    "Change": "Thay đổi",
    "Default": "Mặc định",
    "Full name": "Họ tên",
    "Province / City": "Tỉnh / Thành phố",
    "District": "Quận / Huyện",
    "Wards": "Phường / Xã",
    "Enter address": "Nhập địa chỉ",
    "Notes for orders": "Ghi chú cho đơn hàng",
    "optional": "tuỳ chọn",
    "Create an account to shop faster": "Tạo tài khoản để mua hàng nhanh hơn",
    "Sold": "Đã bán",
    "Please choose color": "Xin vui lòng chọn màu sắc",
    "Please choose a size": "Vui lòng chọn kích cỡ",
    "Find at the store": "Tìm tại cửa hàng",
    "Free shipping": "Miễn phí giao hàng ",
    "For orders from": "Cho đơn hàng từ",
    "Free exchange": "Miễn phí đổi hàng",
    "Within 30 days of purchase.": "Trong 30 ngày kể từ ngày mua.",
    "Description": "Mô tả",
    "Material": "Chất liệu",
    "User manual": "Hướng dẫn sử dụng",
    "Code sp": "Mã sp",
    "Verify phone number": "Xác thực số điện thoại",
    "OTP has just been sent to your phone number": "Mã OTP vừa được gửi đến số điện thoại",
    "Later": "Để sau",
    "Update information": "Cập nhật thông tin",
    "In order for Canifa to have the opportunity to serve you better, please update more information": "Để Canifa có cơ hội phục vụ bạn tốt hơn vui lòng cập nhật thêm thông tin",
    "Effective time": "Thời gian hiệu lực",
    "The validity period has expired!": "Đã hết gian hiệu lực!",
    "Resend OTP": "Gửi lại OTP",
    "Accuracy": "Xác thực",
    "Email": "Email",
    "Change phone number": "Đổi số điện thoại",
    "Sign up to give Canifa a chance to serve you better.": "Đăng ký để Canifa có cơ hội phục vụ bạn tốt hơn.",
    "Thank you for coming back.": "Cảm ơn bạn đã trở lại.",
    "Continue": "Tiếp tục",
    "By choosing continue, you agree to": "Bằng việc chọn tiếp tục, bạn đã đồng ý với",
    "Terms & Conditions": "Điều khoản & Điều kiện",
    "together": "cùng",
    "Privacy Policy and Information Sharing": "Chính sách bảo mật và chia sẻ thông tin",
    "by CANIFA": "của CANIFA",
    "Please enter the phone number": "Vui lòng nhập số điện thoại",
    "Verify OTP": "Xác thực mã OTP",
    "Enter the OTP that was sent to your phone number": "Nhập mã OTP đã được gửi tới số điện thoại",
    "OTP code is incorrect": "Mã OTP không chính xác",
    "Welcome back": "Chào mừng bạn quay trở lại",
    "Please enter your phone number to continue": "Vui lòng nhập số điện thoại để tiếp tục",
    "new": "mới",
    "Sign Up Success": "Đăng ký thành công",
    "Sign up to let Canifa serve you better": "Đăng ký để Canifa phục vụ bạn tốt hơn",
    "Already a member": "Đã là thành viên",
    "Add to cart detail product": "Thêm vào giỏ",
    "Invalid mobile number": "Số điện thoại không hợp lệ",
    "Mobile number cannot be empty": "Số điện thoại không được để trống",
    "Mobile number must be 10 digits": "Số điện thoại phải có 10 chữ số",
    "Login for free to become a loyal customer and receive exclusive offers from CANIFA.":"Đăng nhập miễn phí để trở thành Khách hàng thân thiết và nhận ưu đãi độc quyền từ CANIFA.",
    "Recently Viewed": "Đã xem gần đây",
    "My Wishlist": "Yêu thích",
    "Membership card": "Thẻ thành viên",
    "Address Details": "Sổ địa chỉ",
    "Order History": "Đơn hàng",
    "Coupon Code": "Mã ưu đãi",
    "All Items": "Tất cả",
    "Online": "Online",
    "Offline": "Offline",
    "My Coupon": "My Coupon",
    "Membership Card": "Thẻ thành viên",
    "My Recently Viewed": "Đã xem gần đây",
    "Account Feedback": "Góp ý\nphản hồi",
    "Account Support": "Hỗ trợ",
    "Canifalife": "Canifalife",
};
